module.exports = __webpack_public_path__ + "static/media/dark_circle.fcda5c78.svg";